/**
 * FRONT-855 (Task 3) — shimmer placeholder for the "compose gap": the real
 * pause after a tool call (e.g. a delegation) finishes and before the model
 * starts streaming the final answer text. Today that window renders
 * nothing; this sits exactly where the answer will land and is replaced by
 * the first streamed token (see `isComposingAfterTool` in
 * compose-skeleton-logic.ts for the gating logic).
 *
 * Distinct from the existing "Thinking…" bubble: that one covers the
 * pre-tool phase before anything has happened at all. This one only shows
 * once a tool has already completed.
 *
 * Uses the same muted/hairline tones as the design system's `Skeleton`
 * primitive. The shimmer opacity animation is a dedicated class (not
 * Tailwind's built-in `animate-pulse`) so it can be switched off under
 * `prefers-reduced-motion` — see the `.animate-answer-skeleton-shimmer`
 * rule in app.css — leaving a static placeholder instead.
 */
export function AnswerSkeleton() {
  return (
    <div
      role="status"
      aria-label="Composing answer"
      className="flex flex-col gap-2 px-4 py-3 w-full max-w-md"
    >
      <span className="h-3 w-4/5 rounded-full bg-muted animate-answer-skeleton-shimmer" />
      <span className="h-3 w-3/5 rounded-full bg-muted animate-answer-skeleton-shimmer" />
      <span className="h-3 w-2/5 rounded-full bg-muted animate-answer-skeleton-shimmer" />
    </div>
  );
}
